var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t("common.tips.fuzzySearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tenantId !== _vm.PLATFORM_TENANT_ID,
                      expression: "tenantId!==PLATFORM_TENANT_ID"
                    }
                  ],
                  attrs: { no: "queryInput", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true, "systemAdd")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.SystemAdd")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "101372",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": "110px",
                    "label-position": "left",
                    disabled:
                      _vm.tenantId !== _vm.PLATFORM_TENANT_ID &&
                      _vm.editDialog.form.isPlatform
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "baseInfo.basicData.baseCustomsDeclarationType.code"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "code" },
                        model: {
                          value: _vm.editDialog.form.code,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "code", $$v)
                          },
                          expression: "editDialog.form.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "baseInfo.basicData.baseCustomsDeclarationType.name"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "name" },
                        model: {
                          value: _vm.editDialog.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "name", $$v)
                          },
                          expression: "editDialog.form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "baseInfo.basicData.baseCustomsDeclarationType.englishName"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "englishName" },
                        model: {
                          value: _vm.editDialog.form.englishName,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "englishName", $$v)
                          },
                          expression: "editDialog.form.englishName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "editSave", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "editCancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.platformDialog.visible,
            title: _vm.$t("SeaExport.SystemAdd"),
            width: "950px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.platformDialog, "visible", $event)
            }
          }
        },
        [
          _c("base-customs-declaration-type"),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "add", size: "mini", type: "primary" },
                  on: { click: _vm.addFromPlatform }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.add")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel", size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.platformDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }